export default "__VITE_ASSET__B5G$g$LL__"